import Services from './base-services'

const service = new Services('userAvatar')
import mapParameters from '../utils/map-parameters'

export default {
    getAllFreeAvatar() {
        return service.get('getAllFreeAvatar')
    },
    getAllAvatarByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllAvatarByUser', params)
    },
    getAllPackByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllPackByUser', params)
    },
    getAllByUserAndFree(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllByUserAndFree', params)
    },
    getAllFreePacks() {
        return service.get('getAllFreePacks')
    },
    getSelectedByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getSelectedByUser', params)
    },
    saveUserAvatarCreate(userId: number|string, avatarId: number|string) {
        const params = {
            user: {
                id: userId
            },
            avatar: {
                id: avatarId
            }
        }
        return service.post('saveUserAvatar', params)
    },
    saveUserAvatarUpdate(userSkinId: number|string, userId: number|string, avatarId: number|string, active: boolean|number, selected: boolean|number) {
        const params = {
            id: userSkinId,
            user: {
                id: userId
            },
            avatar: {
                id: avatarId
            },
            active,
            selected
        }
        return service.post('saveUserAvatar', params)
    },
    selectUserAvatar(userId: number|string, avatarId: number|string) {
        const params = {
            user: {
                id: userId
            },
            avatar: {
                id: avatarId
            }
        }
        return service.post('selectUserAvatar', params)
    },
    deleteUserAvatar(userId: number|string, avatarId: number|string) {
        const params = {
            user: {
                id: userId
            },
            avatar: {
                id: avatarId
            }
        }
        return service.post('deleteUserAvatar', params)
    }
}
